import PageForMarketing from 'components/PageForMarketing'
import PageWithTailwind from 'components/PageWithTailwind'
import StartSharingView from 'views/StartSharingView'

const index = () =>
  <PageForMarketing suppressBanners>
    <PageWithTailwind
      title='Start'
      description='Start sharing your blog posts in minutes'
    >
      <StartSharingView />
    </PageWithTailwind>
  </PageForMarketing>

export const getStaticProps = () => {
  return {
    props: {},
  }
}

export default index
